import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ILogin, ILoginResponse, IUserData } from 'src/app/models/auth.models';
import { AuthService } from 'src/app/services/auth.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
declare var $: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  eye : boolean = true;
  @ViewChild("pass") pass: ElementRef;

  loginData:ILogin ={
    userEmail: '',
    userHashPassword: '',
    device: '',
    userType: '',
  }
  loading = false;

  @Output() passwordOtp = new EventEmitter();

  constructor(
    private authService:AuthService,
     private router: Router,
     private snackBar:SnackbarService) { }

  ngOnInit(): void {
  }

  navigateToforgotPassword(){
    $('#login-modal').modal('hide');
    $('#change-password-option-modal').modal('show');
  }

  navigateToSignupPregnant(){
    $('#login-modal').modal('hide');
    $('#signup-modal-pregnant').modal('show');
  }

  navigateToSignupMidwife(){
    $('#login-modal').modal('hide');
    $('#signup-modal-midwife-1').modal('show');
  }

  toggle(){
    this.eye = !this.eye;
    this.pass.nativeElement.type = this.eye ? "password" : "text";
  }

  login(loginModal){
    this.loading = true;
    this.authService.login(this.loginData)
    .subscribe(
      (res:ILoginResponse)=>{
        console.log("Logged In ", res);

        this.authService.storeToken(res.user.authToken);
        this.authService.storeUserInfo(res.user);

        const midwifeId = loginModal.getAttribute('data-midwifeid');

        $('#login-modal').on('show.bs.modal', function(e) {
        });
  
        $('#login-modal').modal('hide');
        this.loading = false;

        if (midwifeId) {
          this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
           this.router.navigate(['/profile', midwifeId]));
        }
        else {
          this.router.navigate(['/dashboard']);
        }
      },
      (err:any)=>{
        console.error("Login API Error", err);
        this.loading = false;
        this.snackBar.openSnackBar(err.error.errorMessage, undefined)
      }
    );
  }

  forgotPassword(){
    this.passwordOtp.emit();
    this.navigateToforgotPassword();
  }

  fetchUserInfoFromEmail(){
    this.loading = true;
    this.authService.fetchUserData({"userEmail":this.loginData.userEmail})
    .subscribe(
      (res:IUserData) => {
        console.log("fetchUserInfoFromEmail ",res);

        this.passwordOtp.emit(res.user);
        this.navigateToforgotPassword();
        this.loading = false;
      },
      (err:HttpErrorResponse)=>{
        console.error("Fetch User Data by email API error",err);
        this.snackBar.openSnackBar(err.error.errorMessage,3000)
        this.loading = false;
      }
    );
  }

}
